<template>
  <v-container
    ref="container"
    style="height: 100vh; width: 100vw"
    class="px-0 py-0"
  >
    <template v-if="isLoading">
      <ProgressBar v-bind:isVisible="isLoading" />
    </template>
    <template v-else>
      <v-container>
        <v-row class="font-weight-light mt-16">
          <v-col class="text-center">
            <vue-circle
              :progress="circleProgress"
              :size="100"
              :reverse="false"
              line-cap="round"
              :fill="fill"
              empty-fill="rgba(0, 0, 0, .1)"
              :animation-start-value="0.0"
              :start-angle="startAngle"
              insert-mode="append"
              :thickness="11"
              :animation="animationConfig"
              :show-percent="false"
              ref="vueCircle"
              :key="currentItem"
            ></vue-circle>
          </v-col>
        </v-row>
        <v-row class="justify-center">
          <v-card width="440" height="180" class="mt-12 mx-4" flat>
            <p class="text-center">{{ assessmentItem }}</p>
          </v-card>
        </v-row>
        <v-row v-if="!isNeutral" class="font-weight-light justify-center">
          <v-card class="" flat>
            <v-btn @click="answer(0)" class="mr-16">Não</v-btn>
            <v-btn @click="answer(1)" class="ml-16">Sim</v-btn>
          </v-card>
        </v-row>
        <v-row v-else class="font-weight-light justify-center">
          <v-card class="" flat>
            <v-btn @click="answer(1)">Continuar</v-btn>
          </v-card>
        </v-row>
      </v-container>
    </template>
  </v-container>
</template>

<script>
import VueCircle from "vue2-circle-progress/src/index.vue";
import { router } from "../router";
import { mapGetters, mapState } from "vuex";
import { Timer } from "easytimer.js";
import ProgressBar from "@/components/ProgressBar.vue";
import { throttle as _throttle } from "lodash";

export default {
  name: "TestColeta2",
  components: {
    VueCircle,
    ProgressBar,
  },
  data: () => ({
    //setup do circle
    fill: { image: require("../assets/circle_conic.png") },
    animationConfig: { duration: 20000, easing: "linear" },
    startAngle: -Math.PI / 2 + 0.15,
    circleProgress: 100,
    isNeutral: false,
    timer: null,
  }),

  methods: {
    answer: function(val) {
      if (
        this.currentItem !== undefined &&
        this.assessmentItems[this.currentItem] !== undefined
      ) {
        let payload = {
          item_id: this.assessmentItems[this.currentItem]["id"],
          item_title: this.assessmentItems[this.currentItem].item_text,
          answer: val,
          answer_time:
            val == 9
              ? 20
              : this.timer.getTimeValues().seconds +
                "." +
                this.timer.getTimeValues().secondTenths,
          docRef: this.currentDocRef,
          execution: this.getExecution,
        };

        this.$store
          .dispatch("answer", payload)
          .then(() => {
            if (this.timer != null || this.timer !== undefined) {
              this.timer.reset();
            }
          })
          .catch(function(error) {});
      }
    },

    removeMouseTrack() {
      this.$refs.container.removeEventListener("mousemove", (e) => {});
    },
  },

  watch: {
    //TODO: reescrever esse trecho para separar as responsabilidades
    currentItem: function(val) {
      if (val <= this.assessmentItems.length - 1) {
        if (this.assessmentItems[this.currentItem].fator === "Neutra") {
          this.isNeutral = true;
        } else {
          this.isNeutral = false;
        }
      }
    },
    shouldTrackMouse: function(val) {},
  },
  computed: {
    ...mapGetters([
      "userProfile",
      "isLoading",
      "assessmentItems",
      "currentItem",
      "currentDocRef",
      "currentItemTitle",
      "shouldTrackMouse",
      "getExecution",
    ]),
    //...mapState(["shouldTrackMouse"]),

    assessmentItem: function() {
      if (
        this.currentItem !== undefined &&
        this.assessmentItems[this.currentItem] !== undefined
      ) {
        return this.assessmentItems[this.currentItem].item_text;
      }
      this.$store.commit("setLoading", true);
      return "";
    },
  },

  //lifecycle hooks

  mounted: function() {
    if (navigator.onLine) {
      this.$store
        .dispatch("startNewAssessment")
        .then(() => {
          this.timer = new Timer();
          this.timer.start({
            //precision: "seconds",
            precision: "secondTenths",
            countdown: false,
            startValues: { seconds: 0 },
            target: { seconds: 20 },
          });
          this.timer.addEventListener("targetAchieved", (e) => {
            this.answer(9);
          });

          this.$refs.container.addEventListener(
            "mousemove",
            _throttle((e) => {
              if (this.shouldTrackMouse) {
                //save mouse data using a store
                const datetime = new Date();
                this.$store.dispatch("saveMouseDynamics", {
                  width: window.innerWidth,
                  height: window.innerHeight,
                  mouseX: e.clientX,
                  mouseY: e.clientY,
                  datetime: datetime.toISOString(),
                });
              }
            }, 100)
          );
        })
        .catch(function(error) {});
    } else {
      alert("Sem conexão");
    }
  },
  beforeDestroy: function() {
    this.timer.stop();
    this.timer.removeEventListener("targetAchieved", (e) => {});
    this.timer = null;

    this.$refs.container.removeEventListener("mousemove", (e) => {});
  },
};
</script>

<style scoped>
/* resolve efeito do botão continuar pressionado no mobile após clique*/
.v-btn:hover:before {
  opacity: 0 !important;
}
</style>
